import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { authSelector } from '../../../home/selectors/loggedUser';
import { setVersion } from '../../actions/config';
import { versionSelector } from '../../selectors/config';
import Control from './Control';

const mapStateToProps = createStructuredSelector({
    loggedUser: authSelector,
    currentVersion: versionSelector
});

const mapDispatchToProps = {
    setVersion
};

export default connect(mapStateToProps, mapDispatchToProps)(Control);